'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/@allenfang/react-toastr/~/react/react.js
// module id = 401
// module chunks = 0